import {useLocation} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "gui-common/redux/store";
import {Button, Icon, Popup, Row, styles, Surface} from "tmwx-design-web/src";
import {Company} from "gui-common/redux/data/company";
import {useEffect} from "react";
import {getATRCompanyList} from "gui-common/redux/action/efe/providerAction";
import {usePermissions} from "tmwx-design-common";
import {authActions} from "gui-common/redux/slice/portal/authSlice";
import constants from 'gui-common/constants.json'

const ProviderSelector = (props: any) => {
    const location = useLocation()
    const dispatch: any = useDispatch()
    const { hasRights } = usePermissions()
    const { style } = props
    const companyList = useSelector<RootState, Company[]>(state => state.atrCompany.companyList);
    const activeCompany = useSelector<RootState, Company>(state => state.auth.activeCompany);
    const canEditProvider = hasRights(["efe_admin_all_efe"]);
    const measurementLocationChildPaths = [
        '/efe/pod/details',
        '/efe/pod/metrics',
        '/efe/pod/mqtt-messages',
        '/efe/pod/params',
        '/efe/pod/commands'
    ];

    const handleProviderChange = (item: Company) => {
        dispatch(authActions.setActiveCompany(item));

        localStorage.setItem(
            constants.ACTIVE_COMPANY,
            JSON.stringify(item)
        );

        if (measurementLocationChildPaths.includes(location.pathname)) {
            window.location.replace('/efe/pod/measurement-location');
            return;
        }

        window.location.reload();
    }

    useEffect(() => {
        if (canEditProvider) {
            dispatch(getATRCompanyList())
        }
    }, [dispatch, hasRights, activeCompany])

    return (
        <div style={{ ...style }}>
            {canEditProvider && companyList && companyList.length !== 0 ? (
                <Popup
                    style={{ display: 'block' }}
                    closeAfterClick
                    triggerComponent={
                        <Button style={{ paddingLeft: 8 }} size='small' iconRight={'unfold_more'} status='neutral' variant='contained' onPress={() => { }}>{activeCompany.name}</Button>}
                >
                    <Surface style={{ ...styles.overflow, minWidth: 150 }} shadow rounded>
                        {companyList.map((item) => (
                            <Row
                                key={item.id}
                                title={item.name}
                                touchable
                                selected={activeCompany.id === item.id}
                                avatar={<Icon name='select_window_outlined' size={18} color={location.pathname.includes(item.name) ? 'primary' : 'neutral'} />}
                                rounded={false}
                                touchableAction={() => handleProviderChange(item)}
                            />
                        ))}
                    </Surface>
                </Popup>
            ) : (
                <Button style={{ paddingLeft: 8 }} size='small' iconRight={'unfold_more'} status='neutral' variant='contained' onPress={() => { }}>
                    {activeCompany.name}
                </Button>
            )}
        </div>
    );
};

export default ProviderSelector;
